export default __webpack_public_path__ + "static/media/candyBar.12fd6942.png";